import { SELECT_MODE } from 'app/constants/table'

export const buildQueryStringFromParams = (
  params,
  enableFilterByZipCode = false,
) => {
  const queryParams = new URLSearchParams()

  queryParams.append('status', params.status || '')

  const subgroups = Array.isArray(params.subgroups)
    ? params.subgroups
    : params.subgroups
      ? [params.subgroups]
      : []

  subgroups.forEach((subgroupId) => {
    queryParams.append('subgroups[]', subgroupId.toString())
  })

  queryParams.append('source', params.source || '')
  queryParams.append(
    'badContact',
    params.badContact !== undefined && params.badContact !== null
      ? params.badContact.toString()
      : '',
  )
  queryParams.append('notificationMethods', params.notificationMethods || '')
  queryParams.append('keyword', params.keyword || '')

  if (enableFilterByZipCode && params.zipCode) {
    queryParams.append('zipCode', params.zipCode)
  }

  return queryParams.toString()
}

export const buildBulkAssignPayload = (
  mode,
  subscriberIds,
  params,
  enableFilterByZipCode = false,
) => {
  return {
    type: mode === SELECT_MODE.SELECTED ? 'ids' : 'query',
    value:
      mode === SELECT_MODE.SELECTED
        ? subscriberIds
        : buildQueryStringFromParams(params, enableFilterByZipCode),
  }
}

export const buildBulkDeletePayload = (
  mode,
  subscriberIds,
  params,
  enableFilterByZipCode = false,
) => {
  return {
    target: {
      type: mode === SELECT_MODE.SELECTED ? 'ids' : 'query',
      value:
        mode === SELECT_MODE.SELECTED
          ? subscriberIds
          : buildQueryStringFromParams(params, enableFilterByZipCode),
    },
  }
}

export const validateBeforeAssign = (mode, subscriberIds, onAssignGroups) => {
  if (mode === SELECT_MODE.SELECTED && subscriberIds.length === 0) {
    return false
  }
  if (!onAssignGroups) {
    return false
  }
  return true
}
